import script from "./PositionTool.vue?vue&type=script&lang=js"
export * from "./PositionTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__